import { MsSql } from "../ms-sql";
import { PgSql } from "../pg-sql";
import { ApiService } from "./api.service";
import { Config } from "./config";
import { MsgService } from "./msg.service";
import { Util } from "./util";

/* eslint-disable prettier/prettier */
declare var console: any;
declare var Excel: any;
declare var Office: any;
declare var localStorage: any;
declare var window: any;

export class Xl {
    errorMessage: string = '';
    msg: any = new MsgService();
    apiService: any = new ApiService();

    async run() {
        try {
            await Excel.run(async (context) => {
                const range = context.workbook.getSelectedRange();
                range.load("address");
                range.format.fill.color = "yellow";
                await context.sync();
                console.log(`The range address was ${range.address}.`);
            });
        } catch (error) {
            console.error(error);
        }
    }

    async setInvoice() {
        // let date = new Date();
        // let invoiceDate = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/-/g, ' ');
        // this.setValuesAt('D5', invoiceDate);
        // this.setValuesAt('B5', Util.generateInvoiceNumber(new Date()));

        try {
            await Excel.run(async (context) => {
                let sheet = context.workbook.worksheets.getActiveWorksheet();
                sheet.load("name");
                await context.sync();
                let sheetName = sheet.name;
                let date = new Date();
                if (sheetName.length == 7 && sheetName.split('-').length == 2) {
                    date = new Date(sheetName);
                    date = Util.getLastDateOfMonth(date);
                }
                let invoiceDate = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/-/g, ' ');
                this.setValuesAt('D5', invoiceDate);
                this.setValuesAt('B5', Util.generateInvoiceNumber(invoiceDate));
                // let range = sheet.getRange(address);
                // range.values = [[value]];

                // console.log(`The range address was ${address}.`);
            });
        } catch (error) {
            this.errorMessage = error;
            console.error(error);
        }
        // let val = this.getValuesAt('D5');
        // let date = val[0][0];
        // this.errorMessage = date;
        // this.msg.info(date);
    }

    async savePDF() {
        // implement save current excel file as pdf
        await Excel.run(async (context) => {
            context.workbook.save(Excel.SaveBehavior.prompt);
            // let docProperties = context.workbook.properties;
            // docProperties.author = "Alex";
            await context.sync();
        });
    }

    async setValues(callback: any) {
        this.errorMessage = '';
        try {
            await Excel.run(async (context) => {
                const range = context.workbook.getSelectedRange();
                range.load(["address", "text"]);
                await context.sync();

                var vals = range.text;

                vals.forEach((row: string[], index: number) => {
                    for (let col = 0; col < row.length; col++) {
                        row[col] = callback(row[col], index, col);
                    }
                });
                range.values = vals;

                await context.sync();
                console.log(`The range address was ${range.address}.`);
            });
        } catch (error) {
            this.errorMessage = error;
            console.error(error);
        }
    }

    async setValuesAt(address: string, value: string) {
        this.errorMessage = '';
        try {
            await Excel.run(async (context) => {
                let sheet = context.workbook.worksheets.getActiveWorksheet();
                let range = sheet.getRange(address);
                range.values = [[value]];

                await context.sync();
                console.log(`The range address was ${address}.`);
            });
        } catch (error) {
            this.errorMessage = error;
            console.error(error);
        }
    }

    async getValuesAt(address: string) {
        this.errorMessage = '';
        try {
            await Excel.run(async (context) => {
                let sheet = context.workbook.worksheets.getActiveWorksheet();
                let range = sheet.getRange(address);
                range.load(["address", "values"]);
                await context.sync();
                return range.values;
            });
        } catch (error) {
            this.errorMessage = error;
            console.error(error);
        }
    }

    async getQuery(queryType: string, callback: any) {
        this.errorMessage = '';
        try {
            await Excel.run(async (context) => {
                const range = context.workbook.getSelectedRange();
                range.load(["address", "text", "rowCount", "columnCount", "rowIndex", "columnIndex"]);
                let sheet = context.workbook.worksheets.getActiveWorksheet();
                let headerRange = sheet.getUsedRange(true).getRow(0);
                headerRange.load(["address", "text"]);
                await context.sync();

                var vals = range.text;
                var headers = headerRange.text[0];

                let rowsRange = sheet.getRangeByIndexes(range.rowIndex, 0, range.rowCount, headers.length);
                sheet.load(["name"]);
                rowsRange.load(["address", "text"]);
                await context.sync();

                vals = rowsRange.text;
                let query = '';
                let sql = Config.databaseType === 'MSSQL' ? new MsSql() : new PgSql();
                switch (queryType) {
                    case 'insert':
                        query = sql.getInsertQuery(sheet.name, headers, vals);
                        break;
                    case 'update':
                        query = sql.getUpdateQuery(sheet.name, headers, vals, range.columnIndex, range.columnIndex + range.columnCount);
                        break;
                    case 'createTable':
                        query = sql.getCreateQuery(sheet.name, headers, vals);
                        break;
                    case 'addColumn':
                        query = sql.getAddColumnQuery(sheet.name, headers, vals, range.columnIndex, range.columnIndex + range.columnCount);
                        break;
                    case 'renameColumn':
                        query = sql.getRenameColumnQuery(sheet.name, headers, range.columnIndex, range.columnIndex + range.columnCount);
                        break;
                }

                callback(query);

                // range.values = vals;
                // await context.sync();
                console.log(`The range address was ${range.address}.`);
            });
        } catch (error) {
            this.errorMessage = error;
            this.msg.error(error);
            console.error(error);
        }
    }

    async loadConnectionString() {
        this.errorMessage = '';
        try {
            await Excel.run(async (context) => {
                let sheet = context.workbook.worksheets.getItem('SQL');
                let settingsRange = sheet.getRange("A2:B20");
                settingsRange.load(["address", "text"]);
                await context.sync();

                if (sheet && settingsRange) {
                    let vals: string[][] = settingsRange.text;
                    let settings: { [k: string]: any; } = {};
                    vals.forEach((row: string[]) => {
                        if (row.length >= 2) {
                            settings[Util.camelCase(row[0])] = row[1];
                        }
                    });
                    // let objSettings = Object.fromEntries(settingsRange.text);
                    // convert keys of settings to camelCase
                    // let settings = Object.keys(objSettings).reduce((acc: { [k: string]: any; }, key) => {
                    //     acc[Util.camelCase(key)] = settingsRange.text[key];
                    //     return acc;
                    // }, {});
                    // let settings = settingsRange.text[0];
                    let connectionString = settings.connectionString;
                    localStorage.setItem('connectionString', connectionString);
                    Config.connectionString = connectionString;
                    Config.apiUrl = settings.apiUrl || Config.apiUrl;
                    Config.limit = +settings.rowLimit || Config.limit;
                    Config.databaseType = settings.databaseType || Util.getDatabaseType(connectionString);
                    // this.msg.info(JSON.stringify(settings));
                    this.msg.info(`${Config.apiUrl} ${Config.limit} ${connectionString}`);
                    this.errorMessage = connectionString;
                }
                else {
                    this.errorMessage = 'SQL sheet not found';
                }
            });
        } catch (error) {
            this.errorMessage = error;
            console.error(error);
        }
    }

    async loadData() {
        this.errorMessage = '';
        try {
            await Excel.run(async (context) => {
                this.msg.info('Loading data...');
                let sheet = context.workbook.worksheets.getActiveWorksheet();
                sheet.load("name");
                await context.sync();
                let db = Config.databaseType === 'MSSQL' ? new MsSql() : new PgSql();

                let sql = {
                    connectionString: Config.connectionString,
                    query: db.getSelectQuery(sheet.name, Config.limit),
                    // limit: Config.limit,
                };
                this.msg.info(`Loading data from ${sheet.name}`);
                let res = await this.apiService.post(`${Config.apiUrl}api/Sql/Query`, sql) || [];
                let headers = (res && res.length) ? Object.keys(res[0]) : [];
                this.msg.info(`Data loaded: ${res.length} rows`);
                if (res.length === 0) {
                    // sql.query = `SELECT * from sys.columns where object_id = OBJECT_ID('${sheet.name}')`;
                    let cols = await this.apiService.post(`${Config.apiUrl}api/Db/TableInfo`, { connectionString: Config.connectionString, tableName: sheet.name }) || [];
                    headers = cols.map((col: any) => col.columnName);
                    this.msg.info(`Header loaded: ${headers}`);
                }

                sheet.getUsedRange().clear();
                let table = sheet.tables.add(Util.getHeaderAddress(headers.length), true);
                table.getHeaderRowRange().values = [headers];

                if (res.length) {
                    let vals = res?.map((row: any) => headers.map((header) => row[header]));
                    table.rows.add(null, vals);
                }

                if (Office.context.requirements.isSetSupported("ExcelApi", "1.2")) {
                    sheet.getUsedRange().format.autofitColumns();
                    sheet.freezePanes.freezeRows(1);
                }

                sheet.activate();
                await context.sync();
                this.msg.success('Data loaded successfully');
            });
        } catch (error) {
            this.errorMessage = error;
            console.error(error);
        }
    }

    async execute(text: string) {
        try {
            let sql = {
                connectionString: Config.connectionString,
                query: text,
            };

            let res = await this.apiService.post(`${Config.apiUrl}api/Sql/Query`, sql);
            let message = res?.length > 0 ? JSON.stringify(res) : 'Executed Successfully';
            this.msg.success(message);
            this.errorMessage = '';
        } catch (error) {
            this.errorMessage = error;
            this.msg.error(error);
            console.error(error);
        }
    }

    async showDialog(text: string) {
        localStorage.setItem('dialogQuery', text);
        Office.context.ui.displayDialogAsync(`${window.location.origin}/sql-dialog.html`, { height: 35, width: 50, displayInIframe: true },
            (result) => {
                const dialog = result.value;
                // dialog.messageChild(JSON.stringify({ type: 'query', data: 'No data' }));
                // dialog.addEventHandler(Office.EventType.DialogEventReceived, processMessage);
                // dialog.addEventHandler(Office.EventType.DialogMessageReceived, processMessage);
                dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (args) => {
                    this.errorMessage = args.message;
                    if (args.message === 'close') {
                        localStorage.removeItem('dialogQuery');
                        dialog.close();
                    }
                    if (args.message === 'execute') {
                        this.errorMessage = 'Executing...';
                        await this.execute(localStorage.getItem('dialogQuery') || '');
                        dialog.close();
                    }
                });
            }
        );
    }
}